import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'picklistItemSort',
})
export class PicklistItemSortPipe implements PipeTransform {
  transform(arr :any[], path :string, direction :'asc' | 'desc' = 'asc') :any[] {
    if (!Array.isArray(arr) || !path) return arr;

    const getValue = (obj :any) :string => {
      return path.split('.').reduce((acc, key) => acc?.[key], obj) ?? '';
    };

    const startsWithNumber = (str :string) :boolean => /^[0-9]/.test(str.trim());

    const sorted = [...arr].sort((a, b) => {
      const valA = getValue(a);
      const valB = getValue(b);

      if (startsWithNumber(valA) && startsWithNumber(valB)) {
        const numA = parseInt(valA);
        const numB = parseInt(valB);

        if (!isNaN(numA) && !isNaN(numB) && numA !== numB) {
          return numA - numB;
        }
      }

      return valA.localeCompare(valB);
    });

    return direction === 'desc' ? sorted.reverse() : sorted;
  }
}
